import { navigateTo } from 'yrv';

export const Navigation = {
  goTo: (slug, reload = false) => {
    if (slug === 'home') {
      navigateTo('/', {
        reload: reload,
      });
    }else if (slug === 'signup') {
      navigateTo('/signup/', {
        reload: reload,
      });
    }else if (slug === 'classes') {
      navigateTo('/clases/', {
        reload: reload,
      });
    }else if (slug === 'free') {
      navigateTo('/clase-gratis/', {
        reload: reload,
      });
    }else if (slug === 'player') {
      navigateTo('/nuestro-reproductor/', {
        reload: reload,
      });
    }else if (slug === 'account') {
      navigateTo('/my-account/', {
        reload: reload,
      });
    }else if (slug === 'terminos') {
      navigateTo('/terminos-y-condiciones/', {
        reload: reload,
      });
    }else if (slug === 'politicas') {
      navigateTo('/politicas-de-privacidad/', {
        reload: reload,
      });
    }else if (slug === 'unete') {
      navigateTo('/unete-a-nuestro-equipo/', {
        reload: reload,
      });
    }else if (slug === 'contacto') {
      navigateTo('/contacto/', {
        reload: reload,
      });
    }else if (slug === 'checkoutMonthly') {
      navigateTo('/checkout/monthly', {
        reload: reload,
      });
    }else if (slug === 'checkoutYearly') {
      navigateTo('/checkout/yearly', {
        reload: reload,
      });
    }else if (slug === 'instructores') {
      navigateTo('/instructores/', {
        reload: reload,
      });
    }else{
      navigateTo('/', {
        reload: reload,
      });
    }
  }
}
